var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"mt-5",attrs:{"align":"center","value":_vm.tabIndex},on:{"input":_vm.changeView}},_vm._l((_vm.tabs),function(tab,index){return _c('b-tab',{key:("tab-" + index),attrs:{"title":tab.title}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }